export enum FontType {
  Arial = 'Arial',
  ArialBlack = 'Arial Black',
  Verdana = 'Verdana',
  Tahoma = 'Tahoma',
  TrebuchetMS = 'Trebuchet MS',
  Impact = 'Impact',
  TimesNewRoman = 'Times New Roman',
  Georgia = 'Georgia',
  AmericanTypewriter = 'American Typewriter',
  Courier = 'Courier',
  LucidaConsole = 'Lucida Console',
  BrushScriptMT = 'Brush Script MT',
  ComicSansMS = 'Comic Sans MS'
}
